"use client";
import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { NotificationsUI } from "./NotificationsUI.js";
const ShowNotification = ({
  successMsg,
  errorMsg
}) => {
  const [showNotification, setShowNotification] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShowNotification(true);
    }, 150);
  }, []);
  if (!showNotification) return null;
  if (successMsg) {
    return /* @__PURE__ */ jsx(NotificationsUI, { message: successMsg, type: "success" });
  } else if (errorMsg) {
    return /* @__PURE__ */ jsx(NotificationsUI, { message: errorMsg, type: "error" });
  } else {
    return null;
  }
};
export {
  ShowNotification
};
